import { Button, LicensePlate } from "@rumbledirect/ui";
import { Tag } from "antd";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

export const recoursesColumns = [
  {
    title: "Kenteken",
    dataIndex: "licensePlate.identifier",
    key: "licensePlate",
    render: (_: any, record: any) => (
      <>
        <LicensePlate country="NL">
          {record.licensePlate?.identifier}
        </LicensePlate>
      </>
    ),
  },
  {
    title: "Bestuurder",
    dataIndex: "driverFullName",
    key: "driverFullName",
  },
  {
    title: "Status",
    dataIndex: "isCompleted",
    render: (isCompleted: boolean) => (
      <Tag color={isCompleted ? "green" : "red"}>
        {isCompleted ? "Ingevuld door bestuurder" : "Openstaand"}
      </Tag>
    ),
  },
  {
    title: "Acties",
    key: "actions",
    render: (_: any, record: any) => (
      <Link to={`/claims/dossiers/${record.dossierId}?activeTab=recourse`}>
        <Button icon={<EyeOutlined />} variant="light" />
      </Link>
    ),
  },
];
